import { Link } from "react-router-dom";

const BlogCard = ({ blog }) => {
  // Function to truncate description to 100 words
  const truncateDescription = (text, wordLimit) => {
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  return (
    <div className="bg-gray-800 p-5 rounded-lg shadow-lg">
      <img
        src={blog.image}
        alt={blog.title}
        className="w-full h-40 object-cover rounded-md"
      />
      <h2 className="text-xl font-semibold mt-4">{blog.title}</h2>
      <p className="text-sm text-gray-400">{blog.date}</p>
      <p className="text-sm text-gray-400">{blog.author}</p>
      <p className="mt-2 text-gray-300">
        {truncateDescription(blog.description, 50)}
      </p>
      <Link to={`/blogs/${blog.id}`} className="text-blue-400 mt-4 block">
        Read More →
      </Link>
    </div>
  );
};

export default BlogCard;
